import React,{useState} from 'react';
import ModernTabs from "../../common/Tabs/ModernTabs";
import BookingRequests from "./BookingRequests";
const BookingRequestsPanel = () => {
const [tabTotal,setTabTotal] = useState(0)
    const updateTabTotal = (tabTotal) => {
        setTabTotal(tabTotal)
    }

    const TabContent = [
        {
            id:'newrequests',
            label: `New Requests ${tabTotal > 0 ? `(${tabTotal})` : ''}`,
            icon:'bi-bell',
            content: <BookingRequests updateTabTotal={updateTabTotal} bookingstatus={0}/>
        },
        {
            id:'followup',
            label:'Follow Up',
            icon:'bi-clock-history',
            content: <BookingRequests bookingstatus={1}/>
        },
        {
            id:'processed',
            label:'Processed Requests',
            icon:'bi-check2-circle',
            content: <BookingRequests bookingstatus={2}/>
        },
        {
            id:'allrequests',
            label:'All Requests',
            icon:'bi-card-list',
            content: <BookingRequests bookingstatus={5}/>
        }

    ]
    return (
        <div>
           <ModernTabs orientation={'horizontal'} tabs={TabContent} className="mt-3"/>

        </div>
    );
};

export default BookingRequestsPanel;